export enum Reviews {
  GOOGLE = 'google',
  FACEBOOK = 'facebook',
}
